import { render, staticRenderFns } from "./CustomerPremiumService.vue?vue&type=template&id=3875a556&scoped=true&"
import script from "./CustomerPremiumService.vue?vue&type=script&lang=ts&"
export * from "./CustomerPremiumService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875a556",
  null
  
)

export default component.exports